import dayjs from 'dayjs';
import { SharedBasketExpiry } from '@/lib/types';
import {
  formatSharedBasketDate,
  SHARED_BASKET_DATE_FORMAT,
} from '@/lib/sharedBasketDate';

// A "month" is 30 days, matching _EXPIRY_DURATIONS in the backend service.
// These drive the preview only - the authoritative expires_at is computed
// server-side and comes back on the create response.
export const ExpiryOptions: {
  value: SharedBasketExpiry;
  days: number;
  label: string;
}[] = [
  { value: '1_day', days: 1, label: '1 day' },
  { value: '1_week', days: 7, label: '1 week' },
  { value: '1_month', days: 30, label: '1 month' },
];

export const expiryLabel = (value: SharedBasketExpiry) =>
  ExpiryOptions.find((option) => option.value === value)?.label ?? '';

export const resolveExpiryDate = (
  value: SharedBasketExpiry,
  expiresAt?: string,
) =>
  expiresAt
    ? formatSharedBasketDate(expiresAt)
    : dayjs()
        .add(
          ExpiryOptions.find((option) => option.value === value)
            ?.days ?? 7,
          'day',
        )
        .format(SHARED_BASKET_DATE_FORMAT);
